
export default {
  name: "NestedSidebar",
  props: {
    label: String,
    items: {type: Array, default: () => []},
  }
}
